import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { FilterEmployeeListActivity } from 'modules/shift_management/activities/FilterEmployeeList'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  activities: {
    filterEmployeeList: {
      component: FilterEmployeeListActivity,
      availableForOne: true,
      guidelines:
        'Applies filters on the shift management page: navigates to the specified date and optionally filters by location, team, and/or specific employees. Use when the user asks to show shifts for a specific date, team, location, or set of employees. This activity is headless — it applies the filters silently without showing a dialog.',
      params: {
        date: {
          guidelines:
            'The date to navigate to in YYYY-MM-DD format. Extract from the user request. If the user says "this week" or "next week", resolve to the Monday of that week. If no date is mentioned, use today.',
        },
        locationId: {
          guidelines:
            'Optional. The ID of the location to filter by. Use fetchLocations or available shift tools to resolve location names to IDs. Omit if no location filter is requested.',
        },
        teamId: {
          guidelines:
            'Optional. The ID of the team to filter by. Use available tools to resolve team names to IDs. Omit if no team filter is requested.',
        },
        employeeIds: {
          guidelines:
            'Optional. Comma-separated employee IDs to filter the shift view. Use fetchEmployees to resolve employee names to IDs. Omit if no specific employees are mentioned.',
        },
      },
    },
  },
} as const satisfies DomainManifest
